import { View } from "react-native-web";
import CustomText from "../atoms/CustomText";

import { useResponsive } from "../../hooks/useResponsive";
import { spacing, colors } from "../../utils/styling";

export default function Footer() {
  const { isMobile } = useResponsive();
  return(
    <View style={{ 
      width: '100%',
      padding: isMobile ? spacing.lg : spacing.xxl,
      backgroundColor: '#262626',
      marginTop: 'auto' 
    }}>
      <View style={{
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: isMobile ? 'center' : 'flex-start',
        maxWidth: 1200,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%'
      }}>
        {/* Left side */}
        <View style={{ alignItems: isMobile ? 'center' : 'flex-start', marginBottom: isMobile ? spacing.md : 0 }}>
          <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: spacing.md }}>
            <img 
              src={require('../../components/img/mp_transparent_logo.png')} 
              alt="FinAI Logo"
              style={{ width: isMobile ? 55 : 65, height: isMobile ? 55 : 65, marginRight: spacing.sm }}
            />
          </View>
          <CustomText style={{ color: colors.white, fontSize: isMobile ? 18 : 18, marginBottom: isMobile ? spacing.md : spacing.xl, textAlign: isMobile ? 'center' : 'left' }}>
            Behavioral finance at its finest
          </CustomText>
        </View>
  
        {/* Right side */}
        <View style={{
          flexDirection: isMobile ? 'row' : 'column', 
          gap: isMobile ? spacing.md : spacing.xl, 
          alignItems: isMobile ? 'center' : 'flex-start', 
          marginBottom: isMobile ? spacing.sm : 0,
          marginTop: isMobile ? 0 : spacing.md,
        }}>
          <CustomText style={{ color: colors.gray[400], fontSize: 14 }}>Privacy</CustomText>
          <CustomText style={{ color: colors.gray[400], fontSize: 14 }}>Terms</CustomText>
        </View>
      </View>
  
      <View style={{
        maxWidth: 1200,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%'
      }}>
        <View style={{ 
          width: '100%', 
          height: 1, 
          backgroundColor: 'rgba(255,255,255,0.1)', 
          marginBottom: isMobile ? spacing.md : spacing.xl 
        }} />
      </View>
  
      <View style={{
        maxWidth: 1200,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%'
      }}>
        <View style={{ 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: isMobile ? 'center' : 'flex-start',
          gap: isMobile ? spacing.md : 0
        }}>
          <CustomText style={{ color: colors.gray[400], fontSize: 14, textAlign: isMobile ? 'center' : 'left' }}>
            Headquartered in Los Angeles, CA | © 2025 Money Personality, Inc. All rights reserved.
          </CustomText>
        </View>
      </View>
    </View>
  );
}